import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "forceUpdate"];
  static values = { emailConfirm: Boolean };

  connect() {
    if (!this.emailConfirmValue) return;

    const message =
      "There is already a user with this email. Do you want to make them a sub user on this account?";
    if (!window.confirm(message)) return;

    this.forceUpdateTarget.value = true;
    this.formTarget.requestSubmit();
  }

  updateStatus(event) {
    const select = event.target;
    const body = new FormData();
    body.append("user[status]", select.value);

    fetch(`/users/${select.dataset.userId}/update`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        Accept: "text/vnd.turbo-stream.html, text/html",
      },
      body,
    });
  }

  get csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']");
    return meta ? meta.content : "";
  }
}
